import type { GemxQlQueryResponse } from '~/core/gemxql/graphql';
import type { ICampaignAnalytic } from '~/types/metric';

import { EXPERIMENT_FIELD } from '../constants/campaign-metrics-v2';
import { buildAnalyticMetric } from './buildAnalyticMetric';
import { extractQueryRows } from '~/core/gemxql/helpers';
import { IVariantType } from '~/modules/campaign/types';
import { ERowReaderMode } from '~/core/gemxql/types';

export interface IExtractCampaignVariantDataParams {
  response?: GemxQlQueryResponse;
  campaignVariantIdA: string;
  campaignVariantIdB: string;
}

export interface IExtractedCampaignVariantData {
  analyticA: ICampaignAnalytic[];
  analyticB: ICampaignAnalytic[];
}

/**
 * Splits a single GROUP-BY-variant listing response into per-variant slots by matching
 * `row.experiment_variant_id`. Empty input variant IDs return an empty slot.
 */
export const extractCampaignVariantData = ({
  response,
  campaignVariantIdA,
  campaignVariantIdB,
}: IExtractCampaignVariantDataParams): IExtractedCampaignVariantData => {
  const rows = extractQueryRows(response);

  const buildSlot = (variantId: string, variantKey: IVariantType): ICampaignAnalytic[] => {
    if (!variantId || !rows.length) return [];
    const row = rows.find((r) => r[EXPERIMENT_FIELD.EXPERIMENT_VARIANT_ID] === variantId);
    if (!row) return [];

    const metric = buildAnalyticMetric({
      row,
      readerMode: ERowReaderMode.DEFAULT,
      date: '',
      variantKey,
    });
    return [
      {
        campaignGroupID: '',
        campaignVariantID: variantId,
        campaignVariantType: '',
        variantKey,
        metrics: [metric],
      },
    ];
  };

  return {
    analyticA: buildSlot(campaignVariantIdA, IVariantType.VARIANT_A),
    analyticB: buildSlot(campaignVariantIdB, IVariantType.VARIANT_B),
  };
};
